import { timeStamp } from './time.util';

export const log = (info, type) => {
  const STYLES = {
    green: 'background: green; color: white; font-size: 12px;',
    red: 'background: #F35531; color: white; font-size: 12px;',
    white: 'background: white; color: black; font-size: 12px;',
    black: 'background: black; color: white; font-size: 12px;',
    yellow: 'background: yellow; color: black; font-size: 12px;',
    blue: 'background: deepblue; color: white; font-size: 12px;',
  };
  const TIME_STYLE = 'font-size: 10px;';
  const TYPES = {
    value: {
      styles: STYLES.green,
      label: '🗄Value',
    },
    error: {
      styles: STYLES.red,
      label: 'Error',
    },
    warn: {
      styles: STYLES.yellow,
      label: 'Warn',
    },
    action: {
      styles: STYLES.blue,
      label: '🦋Action',
    },
    comment: {
      styles: STYLES.black,
      label: 'Comment',
    },
  };
  const logStr = `%c [${timeStamp()}]`;
  if (type) {
    const foundTypeLabel = TYPES[type]?.label || type;
    const foundTypeStyles = TYPES[type]?.styles || STYLES.white;
    console.log(
      `${logStr} %c ${foundTypeLabel} \n`,
      TIME_STYLE,
      foundTypeStyles,
      info
    );
  } else {
    console.log(logStr, TIME_STYLE, info);
  }
};
